// slices/availabilityApiSlice.js
import { apiSlice } from './apiSlice';

export const availabilityApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Create new availability
    createAvailability: builder.mutation({
      query: (data) => ({
        url: '/api/availability',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Availability'],
    }),

    // Get monthly availabilities - FIXED
    getMonthlyAvailabilities: builder.query({
      query: ({ year, month, staffId }) => ({
        url: '/api/availability/monthly',
        params: { 
          year, 
          month,
          ...(staffId && { staffId }) // Only include staffId if it exists
        },
      }),
      providesTags: ['Availability'],
    }),

    // Get daily availabilities
    getDailyAvailabilities: builder.query({
      query: ({ date }) => ({
        url: '/api/availability/daily',
        params: { date },
      }),
      providesTags: ['Availability'],
    }),

    // Update availability
    updateAvailability: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/api/availability/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Availability'],
    }),

    // Delete availability
    deleteAvailability: builder.mutation({
      query: (id) => ({
        url: `/api/availability/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Availability'],
    }),

    // Get availability by ID
    getAvailabilityById: builder.query({
      query: (id) => `/api/availability/${id}`,
      providesTags: ['Availability'],
    }),

    // Manager: Get all availabilities
    getManagerAvailabilities: builder.query({
      query: ({ startDate, endDate, department, status }) => ({
        url: '/api/availability/manager/view',
        params: { startDate, endDate, department, status },
      }),
      providesTags: ['Availability'],
    }),

    // Add new endpoints for weekly availabilities
    getWeeklyAvailabilitiesByStaff: builder.query({
      query: ({ startDate, endDate }) => ({
        url: '/api/availability/weekly/staff',
        params: { startDate, endDate },
      }),
      providesTags: ['Availability'],
    }),
    
    getWeeklyAvailabilitiesForStaff: builder.query({
      query: ({ staffId, startDate, endDate }) => ({
        url: `/api/availability/weekly/staff/${staffId}`,
        params: { startDate, endDate },
      }),
      providesTags: ['Availability'],
    }),

    // Manager: Approve/reject availability
    approveAvailability: builder.mutation({
      query: ({ id, approved, managerComments }) => ({
        url: `/api/availability/${id}/approve`,
        method: 'PUT',
        body: { approved, managerComments },
      }),
      invalidatesTags: ['Availability'],
    }),
  }),
});

export const {
  useCreateAvailabilityMutation,
  useGetMonthlyAvailabilitiesQuery,
  useGetDailyAvailabilitiesQuery,
  useUpdateAvailabilityMutation,
  useDeleteAvailabilityMutation,
  useGetAvailabilityByIdQuery,
  useGetManagerAvailabilitiesQuery,
  useApproveAvailabilityMutation,
  useGetWeeklyAvailabilitiesByStaffQuery,
  useGetWeeklyAvailabilitiesForStaffQuery,
} = availabilityApiSlice;